import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="bg-cream pt-20 pb-24 md:pt-32 md:pb-32 px-6 overflow-hidden" data-id="element-84">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12 md:gap-20" data-id="element-85">
        <div className="flex-1 text-center md:text-left" data-id="element-86">
          <FadeIn data-id="element-87">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4" data-id="element-88">
              Finally Teach Your Parents How to Use Their Smartphone
              <span className="block text-amber text-2xl md:text-3xl lg:text-4xl mt-3 font-medium" data-id="element-89">
                (Without Another 30-Minute Tech Call)
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-90">
            <p className="text-xl md:text-2xl text-warmBrown font-heading leading-relaxed mb-10 max-w-2xl mx-auto md:mx-0" data-id="element-91">
              A simple 32-page guide that finally teaches parents how to text,
              video call, and save photos — without frustration. No more
              "how-do-I-do-this" calls at 9 PM.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-92">
            <CTAButton className="md:items-start" data-id="element-93" />
          </FadeIn>
        </div>

        <div className="flex-1 w-full max-w-md md:max-w-none relative" data-id="element-94">
          <FadeIn delay={0.3} direction="left" data-id="element-95">
            <div className="relative rounded-2xl overflow-hidden shadow-warm-lg border-8 border-white transform md:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-96">
              <img src="https://cdn.magicpatterns.com/uploads/hrcP6UjShSBEaVk2WdkCvo/Text_Message_2.png" alt="Elderly hands holding a smartphone with a confused text message" className="w-full h-auto object-cover" data-id="element-97" />
            </div>
            {/* Decorative background blob */}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-amber-light/30 rounded-full blur-3xl" data-id="element-98"></div>
          </FadeIn>
        </div>
      </div>
    </section>;
}